import { apiCreate } from './ApiBaseActions';
// 問い合わせ
export const API_CREATE_CONTACT = 'API_CREATE_CONTACT';
// コンサルへの問い合わせ
export const API_CREATE_CONTACT_TO_PROFESSIONAL = 'API_CREATE_CONTACT_TO_PROFESSIONAL';
// コンサルユニットへの問い合わせ
export const API_CREATE_CONTACT_TO_PROFESSIONAL_ORGANIZATION_UNIT = 'API_CREATE_CONTACT_TO_PROFESSIONAL_ORGANIZATION_UNIT';
// ヘルプの問い合わせ
export const API_CREATE_HELP_CONTACT = 'API_CREATE_HELP_CONTACT';
export const apiCreateContact = (values, meta) => apiCreate(API_CREATE_CONTACT, '/contact', values, meta);
export const apiCreateContactToProfessional = (values, id, meta) => apiCreate(API_CREATE_CONTACT_TO_PROFESSIONAL, `/contact_for_professional/${id}`, values, meta);
export const apiCreateContactToProfessionalOrganizationUnit = (values, id, meta) => apiCreate(API_CREATE_CONTACT_TO_PROFESSIONAL_ORGANIZATION_UNIT, `/contact_for_professional_organization_unit/${id}`, values, meta);
export const apiCreateHelpContact = (data, meta) => apiCreate(API_CREATE_HELP_CONTACT, '/help_contact', data, meta);
